import * as yup from 'yup';

const phoneRegExp = /^\(?([2-9][0-8][0-9])\)?[-.●]?([2-9][0-9]{2})[-.●]?([0-9]{4})$/;

const validationSchema = yup.object().shape({
  first_name: yup
    .string()
    .min(1)
    .required('Please make a selection'),
  last_name: yup
    .string()
    .min(1)
    .required('Please make a selection'),
  email: yup
    .string()
    .email()
    .required('Please make a selection'),
  phone: yup
    .string()
    .matches(phoneRegExp, 'Please enter a valid phone number')
    .required('Please enter your phone number'),
});

export default validationSchema;